<!-- Cell templates -->
<ng-template #linkedIncidentTpl let-inv>
  @if (inv.incidents?.length) {
    <div class="flex flex-col gap-0.5 max-w-36">
      @for (inc of inv.incidents; track inc.id) {
        <span class="text-xs font-semibold text-primary-600 truncate"
          >#{{ inc.incidentNumber }}</span
        >
      }
    </div>
  } @else {
    <span class="text-slate-400 text-sm">—</span>
  }
</ng-template>

<ng-template #categoriesTpl let-inv>
  <div class="flex flex-wrap gap-1">
    @for (cat of inv.categories; track cat) {
      <span
        class="px-2 py-0.5 rounded-full text-2xs bg-surface-200 text-slate-600 font-medium whitespace-nowrap"
      >
        {{ cat }}
      </span>
    }
  </div>
</ng-template>

<ng-template #personsTpl let-inv>
  <div class="flex items-center gap-2">
    <img src="/icons/persons-icon.svg" class="w-4 h-4 shrink-0" alt="" />
    <span class="text-slate-600 text-sm">{{ inv.personsInvolved.join(', ') }}</span>
  </div>
</ng-template>

<ng-template #dateTpl let-inv>
  <span class="text-slate-600 text-sm whitespace-nowrap">{{ formatDate(inv.createdAt) }}</span>
</ng-template>

<!-- Mobile FAB -->
@if (canCreate) {
  <button
    class="fixed bottom-6 right-6 z-30 md:hidden flex items-center gap-2 pl-4 pr-5 py-3 text-sm font-semibold text-white bg-accent-500 hover:bg-accent-600 rounded-full shadow-lg transition-colors cursor-pointer"
    (click)="showInvestigationModal.set(true)"
  >
    <img src="/icons/plus-icon.svg" class="w-4 h-4 brightness-0 invert" alt="" />
    Create Investigation
  </button>
}

@if (showInvestigationModal()) {
  <app-new-investigation-modal
    (closed)="showInvestigationModal.set(false)"
    (created)="onInvestigationCreated()"
  />
}

<!-- Page layout -->
<div class="flex flex-col h-full bg-surface-100 px-4 sm:px-10 py-6 gap-4">
  <app-filter-bar
    [programs]="programOptions()"
    [categories]="categoryOptions()"
    [statuses]="statusOptions"
    searchPlaceholder="Filter by person, program or ID ..."
    (filtersChange)="onFiltersChange($event)"
  />

  <div
    class="flex-1 min-h-0 bg-white rounded-xl border border-slate-100 overflow-hidden flex flex-col"
  >
    <app-data-table
      [columns]="columns()"
      [rows]="investigations()"
      [pageSize]="pageSize"
      [total]="total()"
      [page]="page()"
      [loading]="loading()"
      [clickableRows]="true"
      (pageChange)="onPageChange($event)"
      (rowAction)="onRowAction($event)"
    />
  </div>
</div>
